export const forecastHistoryStoreSlice = (set) => ({
	fhSelectedOwner: 0,
	fhSelectedDate: 'IGNORE',
	fhSearch: '',
	fhPaginationModel: {
		pageSize: 25,
		page: 0,
	},
	fhMotive: 0,
	fhMargin: false,
	fhSelectedYear: new Date().getFullYear(),
	fhSelectedMarketplace: 1,

	setFhSelectedOwner: (selectedOwner) =>
		set(() => ({ fhSelectedOwner: selectedOwner })),
	resetFhSelectedOwner: () => set(() => ({ fhSelectedOwner: 0 })),
	setFhSelectedDate: (selectedDate) =>
		set(() => ({ fhSelectedDate: selectedDate })),
	resetFhSelectedDate: () => set(() => ({ fhSelectedDate: 'IGNORE' })),
	setFhSearch: (search) => set(() => ({ fhSearch: search })),
	setFhPaginationModel: (paginationModel) =>
		set(() => ({ fhPaginationModel: paginationModel })),
	setFhMotive: (motive) => set(() => ({ fhMotive: motive })),
	resetFhMotive: () => set(() => ({ fhMotive: 0 })),
	setFhMargin: (margin) => set(() => ({ fhMargin: margin })),
	setFhSelectedYear: (selectedYear) =>
		set(() => ({ fhSelectedYear: selectedYear })),
	setFhSelectedMarketplace: (selectedMarketplace) =>
		set(() => ({ fhSelectedMarketplace: selectedMarketplace })),
	resetFhSelectedMarketplace: () => set(() => ({ fhSelectedMarketplace: 1 })),
});
